import { render, staticRenderFns } from "./pdf-interactive-viewer.vue?vue&type=template&id=0c52294a"
import script from "./pdf-interactive-viewer.vue?vue&type=script&lang=ts"
export * from "./pdf-interactive-viewer.vue?vue&type=script&lang=ts"
import style0 from "./pdf-interactive-viewer.vue?vue&type=style&index=0&id=0c52294a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports